export default class OtherFiltersType {
  static get HotDeals() {
    return this.getInstance('hotDeals');
  }

  // This is also know as HOA fee.
  static get HomeOwnersAssociationFee() {
    return this.getInstance('homeOwnersAssociationFee');
  }

  static get PriceReduction() {
    return this.getInstance('priceReduction');
  }

  static get Reviews() {
    return this.getInstance('reviews');
  }

  static get Adult() {
    return this.getInstance('adult');
  }

  static get Price() {
    return this.getInstance('price');
  }

  static get BuilderBrand() {
    return this.getInstance('builderbrand');
  }

  static fromKey(key) {
    const statusMap = {
      hotDeals: OtherFiltersType.HotDeals,
      reviews: OtherFiltersType.Reviews,
      adult: OtherFiltersType.Adult,
      price: OtherFiltersType.Price,
      builder: OtherFiltersType.BuilderBrand,
    };
    return statusMap[key];
  }

  static getInstance(key) {
    if (!this.instances[key]) {
      this.instances[key] = new OtherFiltersType(key);
    }
    return this.instances[key];
  }

  constructor(name) {
    this.name = name;
  }

  toString() {
    return `${this.name}`;
  }
}

Object.defineProperty(OtherFiltersType, 'instances', { value: {} });
